import React, { Component } from "react";

import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

import avatar1 from "../../assets/images/users/avatar-1.jpg";
import profileImg from "../../assets/images/profile-img.png";

class WelcomeComp extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Card className="overflow-hidden">
          {/* <div>
            <Row className="">
              <div className="text-primary p-3">
                <h4 style={{ color: "#74788D" }}>Welcome to Admin Dashboard</h4>
              </div>
            </Row>
          </div> */}
          <CardBody className="pt-4 ">
            <Row className="pt-0 ">
              <Col sm="3" className="pt-0 ">
                <Row className="pt-0 ">
                  <Col sm={"auto"} className="pt-0 ">
                    <div className="avatar-md">
                      <img
                        src={avatar1}
                        alt=""
                        className="img-thumbnail rounded-circle"
                      />
                    </div>
                  </Col>
                  <Col sm={"auto"} className=" pt-2">
                    <h5 style={{ color: "#74788D" }}>
                      Welcome to Admin Dashboard
                    </h5>
                    <h5 className="font-size-15 text-truncate">DigiLab</h5>
                    <p className="text-muted mb-0 text-truncate">Admin</p>
                  </Col>
                </Row>
              </Col>

              <Col sm="9" className="pt-0">
                <div className="pt-2">
                  <Row>
                    <Col xs="auto">
                      <h5 style={{ color: "#74788D" }} className="font-size-15">
                        Total Labs
                      </h5>
                      <p className="text-muted mb-0">13</p>
                    </Col>
                    <Col xs="auto">
                      <h5 style={{ color: "#74788D" }} className="font-size-15">
                        Complaints
                      </h5>
                      <p className="text-muted mb-0">15</p>
                    </Col>
                    <Col xs="auto">
                      <h5 style={{ color: "#74788D" }} className="font-size-15">
                        Registered Clients
                      </h5>
                      <p className="text-muted mb-0">43</p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default WelcomeComp;
